import script from "./BtnAdicionar.vue?vue&type=script&setup=true&lang=js"
export * from "./BtnAdicionar.vue?vue&type=script&setup=true&lang=js"

import "./BtnAdicionar.vue?vue&type=style&index=0&id=42ad5518&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42ad5518"]])

export default __exports__